import {
    CUSTOM_PRICE_LIST_SUCCESS, CUSTOM_PRICE_LIST_ACTION,
    CUSTOM_PRICE_DETAIL_ACTION, CUSTOM_PRICE_DETAIL_SUCCESS, CUSTOM_PRICE_DETAIL_UPDATE_ACTION, CUSTOM_PRICE_DETAIL_CREATE_ACTION
} from '../constants/Types';

export const getListPrices = (filters) => ({ type: CUSTOM_PRICE_LIST_ACTION, filters });
export const setListPrices = (data) => ({ type: CUSTOM_PRICE_LIST_SUCCESS, prices: data.prices, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });

export const getCustomPriceDetail = (id) => ({ type: CUSTOM_PRICE_DETAIL_ACTION, id });
export const setCustomPriceDetail = (price) => ({ type: CUSTOM_PRICE_DETAIL_SUCCESS, price });
export const updateCustomPrice = (price) => ({ type: CUSTOM_PRICE_DETAIL_UPDATE_ACTION, price });
export const createCustomPrice = (price) => ({ type: CUSTOM_PRICE_DETAIL_CREATE_ACTION, price });
